import Input from '@/app/_components/share/formInputs/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export default function WhatsAppUserForm({ onSubmit }) {
  const formSchema = Yup.object().shape({
    name: Yup.string().required('فیلد نام ضرروری می باشد'),
    surname: Yup.string().required('فیلد نام خانوادگی ضرروی می باشد'),
    mobile: Yup.string().required('فیلد شماره همراه ضرروی می باشد'),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });

  return (
    <form
      id="whatsAppcontactUsForm"
      className="flex flex-col items-start justify-start gap-2 w-full "
      onSubmit={handleSubmit(onSubmit)}
    >
      {/* Name input */}
      <div className="w-full">
        <Input
          register={register}
          errors={errors}
          name="name"
          type="text"
          label="نام"
          required={true}
        />
      </div>
      {/* Family input */}
      <div className="w-full">
        <Input
          register={register}
          errors={errors}
          name="surname"
          type="text"
          label="نام خانوادگی"
          required={true}
        />
      </div>
      {/* Phone number input */}
      <div className="w-full">
        <Input
          register={register}
          errors={errors}
          name="mobile"
          type="text"
          label="شماره موبایل"
          required={true}
        />
      </div>
      {/* Contact button */}
      <button
        type="submit"
        className="bg-color-primary my-2 w-full rounded-md text-white px-5 py-2 text-sm font-medium transition-all duration-200"
      >
        ارتباط با کارشناس
      </button>
    </form>
  );
}
